/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-16 09:45:16
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\upgrade.js
 * @
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//获取任务列表
export function listLevelUp(offset, limit,state,tid) {
    const data = {
        user_id: getuser_id(),
        offset,
        limit,
        state,
        tid
    }
    tid==undefined?delete data.tid:tid
    return http({
        url: '/api/levelUp/listLevelUp',
        method: 'post',
        data
    })
}
//获取软件包列表
export function getSoftwarePackageList() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/softwarePackageManager/getSoftwarePackageList',
        method: 'post',
        data
    })
}
//删除升级任务
export function delLevelUp(id) {
    const data = {
        id
    }
    return http({
        url: '/api/levelUp/delLevelUp',
        method: 'post',
        data
    })
}
//搜索排序
export function queryKeyword(keyword, offset, limit, sort,state,tid) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        tname: sort.tName,
        tdescription: sort.tDescription,
        progress: sort.progress,
        spName: sort.spName,
        updatetime: sort.updatetime,
        tid,
        state
    }
    tid==undefined?delete data.tid:tid
    return http({
        url: '/api/levelUp/queryKeyword',
        method: 'post',
        data
    })
}
//删除任务里的设备
export function delSonLevelUp(id) {
    const data = {
        id: id
    }
    return http({
        url: "/api/levelUp/delSonLevelUp",
        method: 'post',
        data
    })
}

//校验序列号
export function checkLevelDevices(groupId, deviceSNs) {
    return http({
        url: '/api/levelUp/checkLevelDevices',
        method: 'post',
        data: { groupId, deviceSNs }
    })
}

//获取获取子任务
export function GetListConfig(parentTid) {
    return http({
        url: '/api/configTask/sub/listConfig',
        method: 'post',
        data:{parentTid}
    })
}
